<template>
  <Modal :preventBackdrop="true" @cancel="close()" v-if="true" :hideExit="isInMaintain"  hClass=""  :cClass="['mw950', { 'in-maintain': isInMaintain }]">
    <template #header>
      <div v-if="isInMaintain" class="header-image-wrapper">
        <img width="100%" src="https://ucarecdn.com/71c346e3-d0d1-4d2d-9e28-ae4992528353/-/format/auto/-/preview/3000x3000/-/quality/lighter/image%20_10_.png">
      </div>
      <div>
        <p class="typo-heading24 typo-medium typo-bold px-4">
          {{ isInMaintain ? "GemPages is under maintenance" : $t("modals.maintain.title") }}
        </p>
      </div>
    </template>
    <template #default>
      <div v-if="!isInMaintain" class="typo-paragraph14 typo-regular text-light-high" v-html="$t('modals.maintain.body')"></div>

      <div v-if="isInMaintain">
        <p class="maintain-content typo-paragraph14 typo-regular text-light-high">Dear valued customers,</p>
        <br />
        <p class="maintain-content typo-paragraph14 typo-regular text-light-high">We will be conducting an important server upgrade for the GemPages app today. Your live store won’t be affected. However, you will not be able to access the GemPages app.</p>
        <br />
        <p class="maintain-content typo-paragraph14 typo-regular text-light-high">Should you require assistance, please contact our support team via Live Chat, email to <span style="color: #3C67FF">support@gempages.help</span> or do try our Help Center or GemPages Facebook Community for information and resources.</p>
        <br />
        <p class="maintain-content typo-paragraph14 typo-regular text-light-high">Sorry for the inconvenience, and we’ll be back before you know it.</p>
        <br />
        <p class="maintain-content typo-paragraph14 typo-regular text-light-high">Kind Regards,<br />The GemPages team</p>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "MaintainModal",
  data() {
    return {
      active: false,
      interval: null,
      maintainAt: null,
      isInMaintain: true
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: state => state.shopInfo
    })
  },
  created() {
    const globalConfigs = this.shopInfo.globalConfigs;
    const maintainAt = globalConfigs.maintainAt; // in seconds
    this.maintainAt = maintainAt;

    let currentTimestamps = this.getCurrentTimestamp();
    let diff = maintainAt - currentTimestamps;
    const notifyBefore = 10 * 60; // in seconds

    if (maintainAt && !this.seenMessage() && diff > 0) {
      clearInterval(this.interval);

      this.interval = setInterval(() => {
        // Open before 10 mins
        // eslint-disable-next-line no-console
        console.log("Server will maintain after: ", diff / 60, " minutes");

        if (diff <= notifyBefore) {
          clearInterval(this.interval);
          this.open();
        }

        currentTimestamps = this.getCurrentTimestamp();
        diff = maintainAt - currentTimestamps;
      }, 60000); // 1 minute = 60 000 milliseconds, run interval every minute
    }

    if (maintainAt && diff <= 0) {
      this.isInMaintain = true;
      this.open();
    }
  },
  methods: {
    close() {
      this.active = false;
      const KEY = `seen-maintain-message-${this.maintainAt}`;
      window.localStorage.setItem(KEY, true);
    },
    open() {
      this.active = true;
    },
    seenMessage() {
      const KEY = `seen-maintain-message-${this.maintainAt}`;
      return window.localStorage.getItem(KEY) == "true";
    },
    getCurrentTimestamp() {
      return new Date().getTime() / 1000; // in seconds
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .in-maintain {
  max-width: 700px;
  .header-image-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 32px;
  }

  hr {
    display: none;
  }
}

::v-deep .gp_modal-backdrop {
  background: #000;
  opacity: 0.8;
}

.maintain-content {
  line-height: 150%;
}
</style>
